const PREMIUMCOLORS = [
  {
    name: "Black",
    mivaname: "Black_2025",
    hex: "#000000",
    rgb: "rgb(0, 0, 0)",
    brief: "Pure black, standard.",
    upcharge: 1.0,
  },
  {
    name: "Aztec Gold",
    mivaname: "Aztec_Gold_0401",
    hex: "#E27023",
    rgb: "rgb(227, 112, 35)",
    brief: "A warm, muted gold with a bronze undertone.",
    upcharge: 1.3,
  },
  {
    name: "Aztec Copper",
    mivaname: "Aztec_Copper_0402",
    hex: "#C14E2F",
    rgb: "rgb(193, 78, 47)",
    brief: "A rich, earthy copper tone with a brownish hue.",
    upcharge: 1.3,
  },
  {
    name: "Black Cherry",
    mivaname: "Black_Cherry_2280",
    hex: "#3F1D28",
    rgb: "rgb(63, 29, 40)",
    brief:
      "A deep, dark red with a hint of purple, resembling ripe black cherry.",
    upcharge: 1.3,
  },
  {
    name: "Blue",
    mivaname: "Blue_3000",
    hex: "#0000FF",
    rgb: "rgb(0, 0, 255)",
    brief: "Pure blue, standard primary color.",
    upcharge: 1.3,
  },
  {
    name: "Brick Red",
    mivaname: "Brick_Red_1875",
    hex: "#AE2935",
    rgb: "rgb(174,41,53)",
    brief: "A dark red with looks like bricks,",
    upcharge: 1.3,
  },
  {
    name: "Brilliant Gold",
    mivaname: "Brilliant_Gold_0400",
    hex: "#FFD700",
    rgb: "rgb(255, 215, 0)",
    brief: "A bright, vibrant gold.",
    upcharge: 1.3,
  },
  {
    name: "Brown",
    mivaname: "Brown_2418",
    hex: "#8B4513",
    rgb: "rgb(139, 69, 19)",
    brief: "A medium brown, akin to saddle brown.",
    upcharge: 1.3,
  },
  {
    name: "Citrus Yellow",
    mivaname: "Citrus_Yellow_0217",
    hex: "#FFC107",
    rgb: "rgb(255, 194, 7)",
    brief: "A bright, zesty yellow with an orange tint.",
    upcharge: 1.3,
  },
  {
    name: "Copper",
    mivaname: "Copper_0253",
    hex: "#C65B46",
    rgb: "rgb(198, 91, 70)",
    brief: "A classic copper shade, warm and metallic.",
    upcharge: 1.3,
  },
  {
    name: "Dark Blue",
    mivaname: "Dark_Blue_2050",
    hex: "#00008B",
    rgb: "rgb(0, 0, 139)",
    brief: "A deep navy blue.",
    upcharge: 1.3,
  },
  {
    name: "Dark Green",
    mivaname: "Dark_Green_2030",
    hex: "#006400",
    rgb: "rgb(0, 100, 0)",
    brief: "A rich forest green.",
    upcharge: 1.3,
  },
  {
    name: "Dark Oxide",
    mivaname: "Dark_Oxide_1315",
    hex: "#3E3F3F",
    rgb: "rgb(62,63,63)",
    brief: "Dark brown.",
    upcharge: 1.3,
  },
  {
    name: "Desert Sand",
    mivaname: "Desert_Sand_4660",
    hex: "#EDC9AF",
    rgb: "rgb(237, 201, 175)",
    brief: "A light, warm beige with a sandy tone.",
    upcharge: 1.3,
  },
  {
    name: "Dove Grey",
    mivaname: "Dove_Grey_4310",
    hex: "#878787",
    rgb: "rgb(135, 135, 135)",
    brief: "A light, neutral grey.",
    upcharge: 1.3,
  },
  {
    name: "Duranodic Bronze",
    mivaname: "Duranodic_Bronze_3130",
    hex: "#4A2C2A",
    rgb: "rgb(74, 44, 42)",
    brief: "A dark, metallic bronze often used in industrial finishes",
    upcharge: 1.3,
  },
  {
    name: "Emerald Green",
    mivaname: "Emerald_Green_0222",
    hex: "#007022",
    rgb: "rgb(0, 112, 34)",
    brief: "A bright, jewel-like green.",
    upcharge: 1.3,
  },
  {
    name: "Federal Green",
    mivaname: "Federal_Green_0259",
    hex: "#005123",
    rgb: "rgb(0, 81, 35)",
    brief: "A deep, muted green often used in official or military contexts.",
    upcharge: 1.3,
  },
  {
    name: "Grey",
    mivaname: "Grey_0209",
    hex: "#808080",
    rgb: "rgb(128, 128, 128)",
    brief: "Medium grey, standard.",
    upcharge: 1.3,
  },
  {
    name: "Hunter Green",
    mivaname: "Hunter_Green_2162",
    hex: "#092D17",
    rgb: "rgb(9, 45, 23)",
    brief: "A dark, earthy green associated with forest hunting tones.",
    upcharge: 1.3,
  },
  {
    name: "Ivory",
    mivaname: "Ivory_2718",
    hex: "#FFFFF0",
    rgb: "rgb(255, 255, 240)",
    brief: "A warm off-white.",
    upcharge: 1.3,
  },
  {
    name: "Lemon Yellow",
    mivaname: "Lemon_Yellow_2037",
    hex: "#F2D927",
    rgb: "rgb(242, 217, 39)",
    brief: "A pale, soft yellow like lemon chiffon.",
    upcharge: 1.3,
  },
  {
    name: "Light Blue",
    mivaname: "Light_Blue_2648",
    hex: "#3371DD",
    rgb: "rgb(51, 113, 221)",
    brief: "A soft sky blue.",
    upcharge: 1.3,
  },
  {
    name: "Light Green",
    mivaname: "Light_Green_2108",
    hex: "#075E11",
    rgb: "rgb(7, 94, 17)",
    brief: "A pastel green.",
    upcharge: 1.3,
  },
  {
    name: "Magenta",
    mivaname: "Magenta_2410",
    hex: "#C11A5E",
    rgb: "rgb(193, 26, 94)",
    brief: "Pure magenta, standard.",
    upcharge: 1.3,
  },
  {
    name: "Mango",
    mivaname: "Mango_0254",
    hex: "#FF9A22",
    rgb: "rgb(255, 154,34)",
    brief: "Dark reddish orange like the Mango fruit.",
    upcharge: 1.3,
  },
  {
    name: "Marine Reef Blue",
    mivaname: "Marine_Reef_Blue_5425",
    hex: "#84A6AD",
    rgb: "rgb(132, 166, 173)",
    brief: "A steel blue with a nautical feel, akin to a coral reef tone.",
    upcharge: 1.3,
  },
  {
    name: "Maroon",
    mivaname: "Maroon_2240",
    hex: "#800000",
    rgb: "rgb(128, 0, 0)",
    brief: "A deep reddish-brown, standard.",
    upcharge: 1.3,
  },
  {
    name: "Medium Blue",
    mivaname: "Medium_Blue_2860",
    hex: "#0000CD",
    rgb: "rgb(0, 0, 205)",
    brief: "A balanced medium blue, slightly darker than pure blue.",
    upcharge: 1.3,
  },
  {
    name: "Medium Bronze",
    mivaname: "Medium_Bronze_0312",
    hex: "#6A4A3C",
    rgb: "rgb(106, 074, 60)",
    brief: "A mid-tone bronze with a warm brown base.",
    upcharge: 1.3,
  },
  {
    name: "Metallic Gold",
    mivaname: "Metallic_Gold_2756",
    hex: "#D4AF37",
    rgb: "rgb(212, 175, 55)",
    brief: "A shiny, metallic gold shade.",
    upcharge: 1.3,
  },
  {
    name: "Metallic Silver",
    mivaname: "Metallic_Silver_8886",
    hex: "#C0C0C0",
    rgb: "rgb(192, 192, 192)",
    brief: "A light, metallic grey resembling silver.",
    upcharge: 1.3,
  },
  {
    name: "Midnight Blue",
    mivaname: "Midnight_Blue_2767",
    hex: "#191970",
    rgb: "rgb(25, 25, 112)",
    brief: "A very dark blue, almost black, evoking a night sky.",
    upcharge: 1.3,
  },
  {
    name: "Old Copper",
    mivaname: "Old_Copper_0314",
    hex: "#73503C",
    rgb: "rgb(115, 80, 60)",
    brief: "A weathered copper tone with a muted, aged appearance.",
    upcharge: 1.3,
  },
  {
    name: "Orange",
    mivaname: "Orange_2119",
    hex: "#FFA500",
    rgb: "rgb(255, 165, 0)",
    brief: "Pure orange, standard.",
    upcharge: 1.3,
  },
  {
    name: "Platinum Grey",
    mivaname: "Platinum_Grey_8808",
    hex: "#9B9B9B",
    rgb: "rgb(155, 155, 155)",
    brief: "A light, metallic grey resembling platinum.",
    upcharge: 1.3,
  },
  {
    name: "Purple",
    mivaname: "Purple_2287",
    hex: "#800080",
    rgb: "rgb(128, 0, 128)",
    brief: "Pure purple, standard.",
    upcharge: 1.3,
  },
  {
    name: "Rampart Orange",
    mivaname: "Rampart_Orange_0256",
    hex: "#FF3000",
    rgb: "rgb(255, 48, 0)",
    brief: "A bold, vibrant orange with a slight reddish tint.",
    upcharge: 1.3,
  },
  {
    name: "Red",
    mivaname: "Red_2793",
    hex: "#FF0000",
    rgb: "rgb(255, 0, 0)",
    brief: "Pure red, standard.",
    upcharge: 1.3,
  },
  {
    name: "Red-Orange",
    mivaname: "Red_Orange_2662",
    hex: "#FF4500",
    rgb: "rgb(255, 69, 0)",
    brief: "A fiery orange-red.",
    upcharge: 1.3,
  },
  {
    name: "Safety Green",
    mivaname: "Safety_Green_8090",
    hex: "#CFEF4B",
    rgb: "rgb(207, 239, 75)",
    brief: "A bright, high-visibility green used in safety contexts.",
    upcharge: 1.3,
  },
  {
    name: "Spring Green",
    mivaname: "Spring_Green_3555",
    hex: "#008E33",
    rgb: "rgb(0, 142, 51)",
    brief: "A bright, fresh green with a cyan tint.",
    upcharge: 1.3,
  },
  {
    name: "Sundance Yellow",
    mivaname: "Sundance_Yellow_0218",
    hex: "#FFB90B",
    rgb: "rgb(255, 185, 11)",
    brief: "A warm, sunny yellow.",
    upcharge: 1.3,
  },
  {
    name: "Teal Blue",
    mivaname: "Teal_Blue_3210",
    hex: "#008080",
    rgb: "rgb(0, 128, 128)",
    brief: "A standard teal, balanced between green and blue.",
    upcharge: 1.3,
  },
  {
    name: "Violet Toner",
    mivaname: "Violet_Toner_0246",
    hex: "#8A2BE2",
    rgb: "rgb(138, 043, 226)",
    brief: "A vibrant violet with a purple-blue mix.",
    upcharge: 1.3,
  },
  {
    name: "White",
    mivaname: "White_5687",
    hex: "#FFFFFF",
    rgb: "rgb(255, 255, 255)",
    brief: "Pure white, standard.",
    upcharge: 1.0,
  },
  {
    name: "Yellow",
    mivaname: "Yellow_2000",
    hex: "#FFFF00",
    rgb: "rgb(255, 255, 0)",
    brief: "Pure yellow, standard.",
    upcharge: 1.3,
  },
];

const BL10COLORS = [
  {
    name: "Black",
    mivaname: "Black_0103",
    hex: "#000000",
    rgb: "rgb(0, 0, 0)",
    brief: "Pure black, standard.",
    upcharge: 1.0,
  },
  {
    name: "White",
    mivaname: "White_0303",
    hex: "#FFFFFF",
    rgb: "rgb(255, 255, 255)",
    brief: "Pure white, standard.",
    upcharge: 1.0,
  },
  {
    name: "Aztec Gold",
    mivaname: "Aztec_Gold_0401",
    hex: "#E27023",
    rgb: "rgb(227, 112, 35)",
    brief: "A warm, muted gold with a bronze undertone.",
    upcharge: 1.15,
  },
  {
    name: "Aztec Copper",
    mivaname: "Aztec_Copper_0402",
    hex: "#C14E2F",
    rgb: "rgb(193, 78, 47)",
    brief: "A rich, earthy copper tone with a brownish hue.",
    upcharge: 1.15,
  },
  {
    name: "Black Cherry",
    mivaname: "Black_Cherry_2280",
    hex: "#3F1D28",
    rgb: "rgb(63, 29, 40)",
    brief:
      "A deep, dark red with a hint of purple, resembling ripe black cherry.",
    upcharge: 1.15,
  },
  {
    name: "Blue",
    mivaname: "Blue_3000",
    hex: "#0000FF",
    rgb: "rgb(0, 0, 255)",
    brief: "Pure blue, standard primary color.",
    upcharge: 1.15,
  },
  {
    name: "Brick Red",
    mivaname: "Brick_Red_1875",
    hex: "#AE2935",
    rgb: "rgb(174,41,53)",
    brief: "A dark red with looks like bricks,",
    upcharge: 1.15,
  },
  {
    name: "Brilliant Gold",
    mivaname: "Brilliant_Gold_0400",
    hex: "#FFD700",
    rgb: "rgb(255, 215, 0)",
    brief: "A bright, vibrant gold.",
    upcharge: 1.15,
  },
  {
    name: "Brown",
    mivaname: "Brown_2418",
    hex: "#8B4513",
    rgb: "rgb(139, 69, 19)",
    brief: "A medium brown, akin to saddle brown.",
    upcharge: 1.15,
  },
  {
    name: "Citrus Yellow",
    mivaname: "Citrus_Yellow_0217",
    hex: "#FFC107",
    rgb: "rgb(255, 194, 7)",
    brief: "A bright, zesty yellow with an orange tint.",
    upcharge: 1.15,
  },
  {
    name: "Copper",
    mivaname: "Copper_0253",
    hex: "#C65B46",
    rgb: "rgb(198, 91, 70)",
    brief: "A classic copper shade, warm and metallic.",
    upcharge: 1.15,
  },
  {
    name: "Chestnut",
    mivaname: "Chestnut_0613",
    hex: "#8B4513",
    rgb: "rgb(139, 69, 19)",
    brief: "A medium saddle brown like the tree.",
    upcharge: 1.0,
  },
  {
    name: "Cobalt Blue",
    mivaname: "Cobalt_Blue_0153",
    hex: "#00008B",
    rgb: "rgb(0, 0, 139)",
    brief: "A deep navy blue.",
    upcharge: 1.0,
  },
  {
    name: "Dark Blue",
    mivaname: "Dark_Blue_2050",
    hex: "#00008B",
    rgb: "rgb(0, 0, 139)",
    brief: "A deep navy blue.",
    upcharge: 1.15,
  },
  {
    name: "Dark Green",
    mivaname: "Dark_Green_2030",
    hex: "#006400",
    rgb: "rgb(0, 100, 0)",
    brief: "A rich forest green.",
    upcharge: 1.15,
  },
  {
    name: "Dark Oxide",
    mivaname: "Dark_Oxide_1315",
    hex: "#3E3F3F",
    rgb: "rgb(62,63,63)",
    brief: "Dark brown.",
    upcharge: 1.15,
  },
  {
    name: "Desert Sand",
    mivaname: "Desert_Sand_4660",
    hex: "#EDC9AF",
    rgb: "rgb(237, 201, 175)",
    brief: "A light, warm beige with a sandy tone.",
    upcharge: 1.15,
  },
  {
    name: "Dove Grey",
    mivaname: "Dove_Grey_4310",
    hex: "#878787",
    rgb: "rgb(135, 135, 135)",
    brief: "A light, neutral grey.",
    upcharge: 1.15,
  },
  {
    name: "Duranodic Bronze",
    mivaname: "Duranodic_Bronze_3130",
    hex: "#4A2C2A",
    rgb: "rgb(74, 44, 42)",
    brief: "A dark, metallic bronze often used in industrial finishes",
    upcharge: 1.15,
  },
  {
    name: "Emerald Green",
    mivaname: "Emerald_Green_0222",
    hex: "#007022",
    rgb: "rgb(0, 112, 34)",
    brief: "A bright, jewel-like green.",
    upcharge: 1.15,
  },
  {
    name: "Federal Green",
    mivaname: "Federal_Green_0259",
    hex: "#005123",
    rgb: "rgb(0, 81, 35)",
    brief: "A deep, muted green often used in official or military contexts.",
    upcharge: 1.15,
  },
  {
    name: "Grey",
    mivaname: "Grey_0209",
    hex: "#808080",
    rgb: "rgb(128, 128, 128)",
    brief: "Medium grey, standard.",
    upcharge: 1.15,
  },
  {
    name: "Hunter Green",
    mivaname: "Hunter_Green_2162",
    hex: "#092D17",
    rgb: "rgb(9, 45, 23)",
    brief: "A dark, earthy green associated with forest hunting tones.",
    upcharge: 1.15,
  },
  {
    name: "Ivory",
    mivaname: "Ivory_2718",
    hex: "#FFFFF0",
    rgb: "rgb(255, 255, 240)",
    brief: "A warm off-white.",
    upcharge: 1.15,
  },
  {
    name: "Lemon Yellow",
    mivaname: "Lemon_Yellow_2037",
    hex: "#F2D927",
    rgb: "rgb(242, 217, 39)",
    brief: "A pale, soft yellow like lemon chiffon.",
    upcharge: 1.15,
  },
  {
    name: "Light Blue",
    mivaname: "Light_Blue_0373",
    hex: "#3371DD",
    rgb: "rgb(51, 113, 221)",
    brief: "A soft sky blue.",
    upcharge: 1.0,
  },
  {
    name: "Light Green",
    mivaname: "Light_Green_2108",
    hex: "#075E11",
    rgb: "rgb(7, 94, 17)",
    brief: "A pastel green.",
    upcharge: 1.15,
  },
  {
    name: "Magenta",
    mivaname: "Magenta_2410",
    hex: "#C11A5E",
    rgb: "rgb(193, 26, 94)",
    brief: "Pure magenta, standard.",
    upcharge: 1.15,
  },
  {
    name: "Mango",
    mivaname: "Mango_0254",
    hex: "#FF9A22",
    rgb: "rgb(255, 154, 34)",
    brief: "Dark reddish orange like the Mango fruit.",
    upcharge: 1.15,
  },
  {
    name: "Marine Reef Blue",
    mivaname: "Marine_Reef_Blue_5425",
    hex: "#84A6AD",
    rgb: "rgb(132, 166, 173)",
    brief: "A steel blue with a nautical feel, akin to a coral reef tone.",
    upcharge: 1.15,
  },
  {
    name: "Maroon",
    mivaname: "Maroon_2240",
    hex: "#800000",
    rgb: "rgb(128, 0, 0)",
    brief: "A deep reddish-brown, standard.",
    upcharge: 1.15,
  },
  {
    name: "Medium Blue",
    mivaname: "Medium_Blue_2860",
    hex: "#0000CD",
    rgb: "rgb(0, 0, 205)",
    brief: "A balanced medium blue, slightly darker than pure blue.",
    upcharge: 1.15,
  },
  {
    name: "Medium Bronze",
    mivaname: "Medium_Bronze_0312",
    hex: "#6A4A3C",
    rgb: "rgb(106, 074, 60)",
    brief: "A mid-tone bronze with a warm brown base.",
    upcharge: 1.15,
  },
  {
    name: "Metallic Gold",
    mivaname: "Metallic_Gold_0673",
    hex: "#D4AF37",
    rgb: "rgb(212, 175, 55)",
    brief: "A shiny, metallic gold shade.",
    upcharge: 1.0,
  },
  {
    name: "Silver",
    mivaname: "Silver_0193",
    hex: "#C0C0C0",
    rgb: "rgb(192, 192, 192)",
    brief: "A light, metallic grey resembling silver.",
    upcharge: 1.0,
  },
  {
    name: "Midnight Blue",
    mivaname: "Midnight_Blue_2767",
    hex: "#191970",
    rgb: "rgb(25, 25, 112)",
    brief: "A very dark blue, almost black, evoking a night sky.",
    upcharge: 1.15,
  },
  {
    name: "Old Copper",
    mivaname: "Old_Copper_0314",
    hex: "#73503C",
    rgb: "rgb(115, 80, 60)",
    brief: "A weathered copper tone with a muted, aged appearance.",
    upcharge: 1.15,
  },
  {
    name: "Orange",
    mivaname: "Orange_0623",
    hex: "#FFA500",
    rgb: "rgb(255, 165, 0)",
    brief: "Pure orange, standard.",
    upcharge: 1.0,
  },
  {
    name: "Platinum Grey",
    mivaname: "Platinum_Grey_8808",
    hex: "#9B9B9B",
    rgb: "rgb(155, 155, 155)",
    brief: "A light, metallic grey resembling platinum.",
    upcharge: 1.15,
  },
  {
    name: "Purple",
    mivaname: "Purple_2287",
    hex: "#800080",
    rgb: "rgb(128, 0, 128)",
    brief: "Pure purple, standard.",
    upcharge: 1.15,
  },
  {
    name: "Rampart Orange",
    mivaname: "Rampart_Orange_0256",
    hex: "#FF3000",
    rgb: "rgb(255, 48, 0)",
    brief: "A bold, vibrant orange with a slight reddish tint.",
    upcharge: 1.15,
  },
  {
    name: "Red",
    mivaname: "Red_0133",
    hex: "#FF0000",
    rgb: "rgb(255, 0, 0)",
    brief: "Pure red, standard.",
    upcharge: 1.0,
  },
  {
    name: "Red-Orange",
    mivaname: "Red_Orange_2662",
    hex: "#FF4500",
    rgb: "rgb(255, 69, 0)",
    brief: "A fiery orange-red.",
    upcharge: 1.15,
  },
  {
    name: "Safety Green",
    mivaname: "Safety_Green_8090",
    hex: "#CFEF4B",
    rgb: "rgb(207, 239, 75)",
    brief: "A bright, high-visibility green used in safety contexts.",
    upcharge: 1.15,
  },
  {
    name: "Spring Green",
    mivaname: "Spring_Green_0173",
    hex: "#008E33",
    rgb: "rgb(0, 142, 51)",
    brief: "A bright, fresh green with a cyan tint.",
    upcharge: 1.0,
  },
  {
    name: "Sundance Yellow",
    mivaname: "Sundance_Yellow_0218",
    hex: "#FFB90B",
    rgb: "rgb(255, 185, 11)",
    brief: "A warm, sunny yellow.",
    upcharge: 1.15,
  },
  {
    name: "Teal Blue",
    mivaname: "Teal_Blue_3210",
    hex: "#008080",
    rgb: "rgb(0, 128, 128)",
    brief: "A standard teal, balanced between green and blue.",
    upcharge: 1.15,
  },
  {
    name: "Violet Toner",
    mivaname: "Violet_Toner_0246",
    hex: "#8A2BE2",
    rgb: "rgb(138, 43, 226)",
    brief: "A vibrant violet with a purple-blue mix.",
    upcharge: 1.15,
  },
  {
    name: "Yellow",
    mivaname: "Yellow_0143",
    hex: "#FFFF00",
    rgb: "rgb(255, 255, 0)",
    brief: "Pure yellow, standard.",
    upcharge: 1.0,
  },
];

const PAINTEDMETALCOLORS = [
  {
    name: "Unpainted",
    mivaname: "Unpainted",
    hex: "#A8AAB1",
    rgb: "rgb(168, 170, 177)",
    brief: "Unpainted.",
    upcharge: 1.0,
  },
  {
    name: "Aztec Gold",
    mivaname: "Aztec_Gold_0401",
    hex: "#E27023",
    rgb: "rgb(227, 112, 35)",
    brief: "A warm, muted gold with a bronze undertone.",
    upcharge: 1.0,
  },
  {
    name: "Aztec Copper",
    mivaname: "Aztec_Copper_0402",
    hex: "#C14E2F",
    rgb: "rgb(193, 78, 47)",
    brief: "A rich, earthy copper tone with a brownish hue.",
    upcharge: 1.0,
  },
  {
    name: "Black",
    mivaname: "Black_2025",
    hex: "#000000",
    rgb: "rgb(0, 0, 0)",
    brief: "Pure black, standard.",
    upcharge: 1.0,
  },
  {
    name: "Black Cherry",
    mivaname: "Black_Cherry_2280",
    hex: "#3F1D28",
    rgb: "rgb(63, 29, 40)",
    brief:
      "A deep, dark red with a hint of purple, resembling ripe black cherry.",
    upcharge: 1.0,
  },
  {
    name: "Blue",
    mivaname: "Blue_3000",
    hex: "#0000FF",
    rgb: "rgb(0, 0, 255)",
    brief: "Pure blue, standard primary color.",
    upcharge: 1.0,
  },
  {
    name: "Brick Red",
    mivaname: "Brick_Red_1875",
    hex: "#AE2935",
    rgb: "rgb(174,41,53)",
    brief: "A dark red with looks like bricks,",
    upcharge: 1.0,
  },
  {
    name: "Brilliant Gold",
    mivaname: "Brilliant_Gold_0400",
    hex: "#FFD700",
    rgb: "rgb(255, 215, 0)",
    brief: "A bright, vibrant gold.",
    upcharge: 1.0,
  },
  {
    name: "Brown",
    mivaname: "Brown_2418",
    hex: "#8B4513",
    rgb: "rgb(139,69, 19)",
    brief: "A medium brown, akin to saddle brown.",
    upcharge: 1.0,
  },
  {
    name: "Citrus Yellow",
    mivaname: "Citrus_Yellow_0217",
    hex: "#FFC107",
    rgb: "rgb(255, 194, 7)",
    brief: "A bright, zesty yellow with an orange tint.",
    upcharge: 1.0,
  },
  {
    name: "Copper",
    mivaname: "Copper_0253",
    hex: "#C65B46",
    rgb: "rgb(198, 91, 70)",
    brief: "A classic copper shade, warm and metallic.",
    upcharge: 1.0,
  },
  {
    name: "Dark Blue",
    mivaname: "Dark_Blue_2050",
    hex: "#00008B",
    rgb: "rgb(0, 0, 139)",
    brief: "A deep navy blue.",
    upcharge: 1.0,
  },
  {
    name: "Dark Green",
    mivaname: "Dark_Green_2030",
    hex: "#006400",
    rgb: "rgb(0, 100, 0)",
    brief: "A rich forest green.",
    upcharge: 1.0,
  },
  {
    name: "Dark Oxide",
    mivaname: "Dark_Oxide_1315",
    hex: "#3E3F3F",
    rgb: "rgb(62,63,63)",
    brief: "Dark brown.",
    upcharge: 1.0,
  },
  {
    name: "Desert Sand",
    mivaname: "Desert_Sand_4660",
    hex: "#EDC9AF",
    rgb: "rgb(237, 201, 175)",
    brief: "A light, warm beige with a sandy tone.",
    upcharge: 1.0,
  },
  {
    name: "Dove Grey",
    mivaname: "Dove_Grey_4310",
    hex: "#878787",
    rgb: "rgb(135, 135, 135)",
    brief: "A light, neutral grey.",
    upcharge: 1.0,
  },
  {
    name: "Duranodic Bronze",
    mivaname: "Duranodic_Bronze_3130",
    hex: "#4A2C2A",
    rgb: "rgb(74, 44, 42)",
    brief: "A dark, metallic bronze often used in industrial finishes",
    upcharge: 1.0,
  },
  {
    name: "Emerald Green",
    mivaname: "Emerald_Green_0222",
    hex: "#007022",
    rgb: "rgb(0, 112, 34)",
    brief: "A bright, jewel-like green.",
    upcharge: 1.0,
  },
  {
    name: "Federal Green",
    mivaname: "Federal_Green_0259",
    hex: "#005123",
    rgb: "rgb(0, 81, 35)",
    brief: "A deep, muted green often used in official or military contexts.",
    upcharge: 1.0,
  },
  {
    name: "Grey",
    mivaname: "Grey_0209",
    hex: "#808080",
    rgb: "rgb(128, 128, 128)",
    brief: "Medium grey, standard.",
    upcharge: 1.0,
  },
  {
    name: "Hunter Green",
    mivaname: "Hunter_Green_2162",
    hex: "#092D17",
    rgb: "rgb(9, 45, 23)",
    brief: "A dark, earthy green associated with forest hunting tones.",
    upcharge: 1.0,
  },
  {
    name: "Ivory",
    mivaname: "Ivory_2718",
    hex: "#FFFFF0",
    rgb: "rgb(255, 255, 240)",
    brief: "A warm off-white.",
    upcharge: 1.0,
  },
  {
    name: "Lemon Yellow",
    mivaname: "Lemon_Yellow_2037",
    hex: "#F2D927",
    rgb: "rgb(242, 217, 39)",
    brief: "A pale, soft yellow like lemon chiffon.",
    upcharge: 1.0,
  },
  {
    name: "Light Blue",
    mivaname: "Light_Blue_2648",
    hex: "#3371DD",
    rgb: "rgb(51, 113, 221)",
    brief: "A soft sky blue.",
    upcharge: 1.0,
  },
  {
    name: "Light Green",
    mivaname: "Light_Green_2108",
    hex: "#075E11",
    rgb: "rgb(7, 94, 17)",
    brief: "A pastel green.",
    upcharge: 1.0,
  },
  {
    name: "Magenta",
    mivaname: "Magenta_2410",
    hex: "#C11A5E",
    rgb: "rgb(193, 26, 94)",
    brief: "Pure magenta, standard.",
    upcharge: 1.0,
  },
  {
    name: "Mango",
    mivaname: "Mango_0254",
    hex: "#FF9A22",
    rgb: "rgb(255, 154, 34)",
    brief: "Dark reddish orange like the Mango fruit.",
    upcharge: 1.0,
  },
  {
    name: "Marine Reef Blue",
    mivaname: "Marine_Reef_Blue_5425",
    hex: "#84A6AD",
    rgb: "rgb(132, 166, 173)",
    brief: "A steel blue with a nautical feel, akin to a coral reef tone.",
    upcharge: 1.0,
  },
  {
    name: "Maroon",
    mivaname: "Maroon_2240",
    hex: "#800000",
    rgb: "rgb(128, 0, 0)",
    brief: "A deep reddish-brown, standard.",
    upcharge: 1.0,
  },
  {
    name: "Medium Blue",
    mivaname: "Medium_Blue_2860",
    hex: "#0000CD",
    rgb: "rgb(0, 0, 205)",
    brief: "A balanced medium blue, slightly darker than pure blue.",
    upcharge: 1.0,
  },
  {
    name: "Medium Bronze",
    mivaname: "Medium_Bronze_0312",
    hex: "#6A4A3C",
    rgb: "rgb(106, 74, 60)",
    brief: "A mid-tone bronze with a warm brown base.",
    upcharge: 1.0,
  },
  {
    name: "Metallic Gold",
    mivaname: "Metallic_Gold_2756",
    hex: "#D4AF37",
    rgb: "rgb(212, 175, 55)",
    brief: "A shiny, metallic gold shade.",
    upcharge: 1.0,
  },
  {
    name: "Metallic Silver",
    mivaname: "Metallic_Silver_8886",
    hex: "#C0C0C0",
    rgb: "rgb(192, 192, 192)",
    brief: "A light, metallic grey resembling silver.",
    upcharge: 1.0,
  },
  {
    name: "Midnight Blue",
    mivaname: "Midnight_Blue_2767",
    hex: "#191970",
    rgb: "rgb(25, 25, 112)",
    brief: "A very dark blue, almost black, evoking a night sky.",
    upcharge: 1.0,
  },
  {
    name: "Old Copper",
    mivaname: "Old_Copper_0314",
    hex: "#73503C",
    rgb: "rgb(115, 80, 60)",
    brief: "A weathered copper tone with a muted, aged appearance.",
    upcharge: 1.0,
  },
  {
    name: "Orange",
    mivaname: "Orange_2119",
    hex: "#FFA500",
    rgb: "rgb(255, 165, 0)",
    brief: "Pure orange, standard.",
    upcharge: 1.0,
  },
  {
    name: "Platinum Grey",
    mivaname: "Platinum_Grey_8808",
    hex: "#9B9B9B",
    rgb: "rgb(155, 155, 155)",
    brief: "A light, metallic grey resembling platinum.",
    upcharge: 1.0,
  },
  {
    name: "Purple",
    mivaname: "Purple_2287",
    hex: "#800080",
    rgb: "rgb(128, 0, 128)",
    brief: "Pure purple, standard.",
    upcharge: 1.0,
  },
  {
    name: "Rampart Orange",
    mivaname: "Rampart_Orange_0256",
    hex: "#FF3000",
    rgb: "rgb(255, 48, 0)",
    brief: "A bold, vibrant orange with a slight reddish tint.",
    upcharge: 1.0,
  },
  {
    name: "Red",
    mivaname: "Red_2793",
    hex: "#FF0000",
    rgb: "rgb(255, 0, 0)",
    brief: "Pure red, standard.",
    upcharge: 1.0,
  },
  {
    name: "Red-Orange",
    mivaname: "Red_Orange_2662",
    hex: "#FF4500",
    rgb: "rgb(255, 69, 0)",
    brief: "A fiery orange-red.",
    upcharge: 1.0,
  },
  {
    name: "Safety Green",
    mivaname: "Safety_Green_8090",
    hex: "#CFEF4B",
    rgb: "rgb(207, 239, 75)",
    brief: "A bright, high-visibility green used in safety contexts.",
    upcharge: 1.0,
  },
  {
    name: "Spring Green",
    mivaname: "Spring_Green_3555",
    hex: "#008E33",
    rgb: "rgb(0, 142, 51)",
    brief: "A bright, fresh green with a cyan tint.",
    upcharge: 1.0,
  },
  {
    name: "Sundance Yellow",
    mivaname: "Sundance_Yellow_0218",
    hex: "#FFB90B",
    rgb: "rgb(255, 185, 11)",
    brief: "A warm, sunny yellow.",
    upcharge: 1.0,
  },
  {
    name: "Teal Blue",
    mivaname: "Teal_Blue_3210",
    hex: "#008080",
    rgb: "rgb(0, 128, 128)",
    brief: "A standard teal, balanced between green and blue.",
    upcharge: 1.0,
  },
  {
    name: "Violet Toner",
    mivaname: "Violet_Toner_0246",
    hex: "#8A2BE2",
    rgb: "rgb(138, 43, 226)",
    brief: "A vibrant violet with a purple-blue mix.",
    upcharge: 1.0,
  },
  {
    name: "White",
    mivaname: "White_Opaque_7508",
    hex: "#FFFFFF",
    rgb: "rgb(255, 255, 255)",
    brief: "Pure white, standard.",
    upcharge: 1.0,
  },
  {
    name: "Yellow",
    mivaname: "Yellow_2000",
    hex: "#FFFF00",
    rgb: "rgb(255, 255, 0)",
    brief: "Pure yellow, standard.",
    upcharge: 1.0,
  },
];

const PFL100COLORS = [
  {
    name: "Brushed Aluminum",
    mivaname: "FCMA_BSA",
    hex: "#A8AAB1",
    rgb: "rgb(168, 170, 177)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Polished Natural Aluminum",
    mivaname: "FCMA_SSA",
    hex: "#C0CAD3",
    rgb: "rgb(192, 202, 211)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Satin Gold",
    mivaname: "FCMA_BSG",
    hex: "#BFC562",
    rgb: "rgb(191, 197, 98)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Gold Anodized Aluminum",
    mivaname: "FCMA_GAA",
    hex: "#BD9244",
    rgb: "rgb(189, 146, 68)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Brushed Light Brass",
    mivaname: "FCMA_BSB",
    hex: "#D6C65D",
    rgb: "rgb(214, 198, 93)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Brushed Brass",
    mivaname: "FCMA_SSB",
    hex: "#A6914D",
    rgb: "rgb(166, 145, 77)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Polished Brass",
    mivaname: "FCMA_BAA",
    hex: "#D4BC5F",
    rgb: "rgb(212, 188, 95)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Brushed Medium Bronze",
    mivaname: "FCMA_BBR",
    hex: "#5E4C33",
    rgb: "rgb(94, 76, 51)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Aztec Gold",
    mivaname: "Aztec_Gold_0401",
    hex: "#E27023",
    rgb: "rgb(227, 112, 35)",
    brief: "A warm, muted gold with a bronze undertone.",
    upcharge: 1.0,
  },
  {
    name: "Aztec Copper",
    mivaname: "Aztec_Copper_0402",
    hex: "#C14E2F",
    rgb: "rgb(193, 78, 47)",
    brief: "A rich, earthy copper tone with a brownish hue.",
    upcharge: 1.0,
  },
  {
    name: "Black",
    mivaname: "Black_2025",
    hex: "#000000",
    rgb: "rgb(0, 0, 0)",
    brief: "Pure black, standard.",
    upcharge: 1.0,
  },
  {
    name: "Black Cherry",
    mivaname: "Black_Cherry_2280",
    hex: "#3F1D28",
    rgb: "rgb(63, 29, 40)",
    brief:
      "A deep, dark red with a hint of purple, resembling ripe black cherry.",
    upcharge: 1.0,
  },
  {
    name: "Blue",
    mivaname: "Blue_3000",
    hex: "#0000FF",
    rgb: "rgb(0, 0, 255)",
    brief: "Pure blue, standard primary color.",
    upcharge: 1.0,
  },
  {
    name: "Brilliant Gold",
    mivaname: "Brilliant_Gold_0400",
    hex: "#FFD700",
    rgb: "rgb(255, 215, 0)",
    brief: "A bright, vibrant gold.",
    upcharge: 1.0,
  },
  {
    name: "Brown",
    mivaname: "brown_2418",
    hex: "#8B4513",
    rgb: "rgb(139, 69, 19)",
    brief: "A medium brown, akin to saddle brown.",
    upcharge: 1.0,
  },
  {
    name: "Citrus Yellow",
    mivaname: "Citrus_Yellow_0217",
    hex: "#FFC107",
    rgb: "rgb(255, 194, 7)",
    brief: "A bright, zesty yellow with an orange tint.",
    upcharge: 1.0,
  },
  {
    name: "Copper",
    mivaname: "Copper_0253",
    hex: "#C65B46",
    rgb: "rgb(198, 91, 70)",
    brief: "A classic copper shade, warm and metallic.",
    upcharge: 1.0,
  },
  {
    name: "Dark Blue",
    mivaname: "Dark_Blue_2050",
    hex: "#00008B",
    rgb: "rgb(0, 0, 139)",
    brief: "A deep navy blue.",
    upcharge: 1.0,
  },
  {
    name: "Dark Green",
    mivaname: "Dark_Green_2030",
    hex: "#006400",
    rgb: "rgb(0, 100, 0)",
    brief: "A rich forest green.",
    upcharge: 1.0,
  },
  {
    name: "Dark Oxide",
    mivaname: "Dark_Oxide_1315",
    hex: "#3E3F3F",
    rgb: "rgb(62,63,63)",
    brief: "Dark brown.",
    upcharge: 1.0,
  },
  {
    name: "Desert Sand",
    mivaname: "Desert_Sand_4660",
    hex: "#EDC9AF",
    rgb: "rgb(237, 201, 175)",
    brief: "A light, warm beige with a sandy tone.",
    upcharge: 1.0,
  },
  {
    name: "Dove Grey",
    mivaname: "Dove_Grey_4310",
    hex: "#878787",
    rgb: "rgb(135, 135, 135)",
    brief: "A light, neutral grey.",
    upcharge: 1.0,
  },
  {
    name: "Duranodic Bronze",
    mivaname: "Duranodic_Bronze_3130",
    hex: "#4A2C2A",
    rgb: "rgb(74, 44, 42)",
    brief: "A dark, metallic bronze often used in industrial finishes",
    upcharge: 1.0,
  },
  {
    name: "Emerald Green",
    mivaname: "Emerald_Green_0222",
    hex: "#007022",
    rgb: "rgb(0, 112, 34)",
    brief: "A bright, jewel-like green.",
    upcharge: 1.0,
  },
  {
    name: "Federal Green",
    mivaname: "Federal_Green_0259",
    hex: "#005123",
    rgb: "rgb(0, 81, 35)",
    brief: "A deep, muted green often used in official or military contexts.",
    upcharge: 1.0,
  },
  {
    name: "Grey",
    mivaname: "Grey",
    hex: "#808080",
    rgb: "rgb(128, 128, 128)",
    brief: "Medium grey, standard.",
    upcharge: 1.0,
  },
  {
    name: "Hunter Green",
    mivaname: "Hunter_Green_2162",
    hex: "#092D17",
    rgb: "rgb(9, 45, 23)",
    brief: "A dark, earthy green associated with forest hunting tones.",
    upcharge: 1.0,
  },
  {
    name: "Ivory",
    mivaname: "Ivory_2718",
    hex: "#FFFFF0",
    rgb: "rgb(255, 255, 240)",
    brief: "A warm off-white.",
    upcharge: 1.0,
  },
  {
    name: "Lemon Yellow",
    mivaname: "Lemon_Yellow_2037",
    hex: "#F2D927",
    rgb: "rgb(242, 217, 39)",
    brief: "A pale, soft yellow like lemon chiffon.",
    upcharge: 1.0,
  },
  {
    name: "Light Blue",
    mivaname: "Light_Blue_2648",
    hex: "#3371DD",
    rgb: "rgb(51, 113, 221)",
    brief: "A soft sky blue.",
    upcharge: 1.0,
  },
  {
    name: "Light Green",
    mivaname: "Light_Green_2108",
    hex: "#075E11",
    rgb: "rgb(7, 94, 17)",
    brief: "A pastel green.",
    upcharge: 1.0,
  },
  {
    name: "Magenta",
    mivaname: "Magenta_2410",
    hex: "#C11A5E",
    rgb: "rgb(193, 26, 94)",
    brief: "Pure magenta, standard.",
    upcharge: 1.0,
  },
  {
    name: "Marine Reef Blue",
    mivaname: "Marine_Reef_Blue_5425",
    hex: "#84A6AD",
    rgb: "rgb(132, 166, 173)",
    brief: "A steel blue with a nautical feel, akin to a coral reef tone.",
    upcharge: 1.0,
  },
  {
    name: "Maroon",
    mivaname: "Maroon_2240",
    hex: "#800000",
    rgb: "rgb(128, 0, 0)",
    brief: "A deep reddish-brown, standard.",
    upcharge: 1.0,
  },
  {
    name: "Medium Blue",
    mivaname: "Medium_Blue_2860",
    hex: "#0000CD",
    rgb: "rgb(0, 0, 205)",
    brief: "A balanced medium blue, slightly darker than pure blue.",
    upcharge: 1.0,
  },
  {
    name: "Medium Bronze",
    mivaname: "Medium_Bronze_0312",
    hex: "#6A4A3C",
    rgb: "rgb(106, 74, 60)",
    brief: "A mid-tone bronze with a warm brown base.",
    upcharge: 1.0,
  },
  {
    name: "Metallic Gold",
    mivaname: "Metallic_Gold_2756",
    hex: "#D4AF37",
    rgb: "rgb(212, 175, 55)",
    brief: "A shiny, metallic gold shade.",
    upcharge: 1.0,
  },
  {
    name: "Metallic Silver",
    mivaname: "Metallic_Silver_8886",
    hex: "#C0C0C0",
    rgb: "rgb(192, 192, 192)",
    brief: "A light, metallic grey resembling silver.",
    upcharge: 1.0,
  },
  {
    name: "Midnight Blue",
    mivaname: "Midnight_Blue_2767",
    hex: "#191970",
    rgb: "rgb(25, 25, 112)",
    brief: "A very dark blue, almost black, evoking a night sky.",
    upcharge: 1.0,
  },
  {
    name: "Old Copper",
    mivaname: "Old_Copper_0314",
    hex: "#73503C",
    rgb: "rgb(115, 80, 60)",
    brief: "A weathered copper tone with a muted, aged appearance.",
    upcharge: 1.0,
  },
  {
    name: "Orange",
    mivaname: "Orange_2119",
    hex: "#FFA500",
    rgb: "rgb(255, 165, 0)",
    brief: "Pure orange, standard.",
    upcharge: 1.0,
  },
  {
    name: "Platinum Grey",
    mivaname: "Platinum_Grey_8808",
    hex: "#9B9B9B",
    rgb: "rgb(155, 155, 155)",
    brief: "A light, metallic grey resembling platinum.",
    upcharge: 1.0,
  },
  {
    name: "Purple",
    mivaname: "Purple_2287",
    hex: "#800080",
    rgb: "rgb(128, 0, 128)",
    brief: "Pure purple, standard.",
    upcharge: 1.0,
  },
  {
    name: "Rampart Orange",
    mivaname: "Rampart_Orange_0256",
    hex: "#FF3000",
    rgb: "rgb(255, 48, 0)",
    brief: "A bold, vibrant orange with a slight reddish tint.",
    upcharge: 1.0,
  },
  {
    name: "Red",
    mivaname: "Red_2793",
    hex: "#FF0000",
    rgb: "rgb(255, 0, 0)",
    brief: "Pure red, standard.",
    upcharge: 1.0,
  },
  {
    name: "Red-Orange",
    mivaname: "Red_Orange_2662",
    hex: "#FF4500",
    rgb: "rgb(255, 069, 0)",
    brief: "A fiery orange-red.",
    upcharge: 1.0,
  },
  {
    name: "Safety Green",
    mivaname: "Safety_Green_8090",
    hex: "#CFEF4B",
    rgb: "rgb(207, 239, 75)",
    brief: "A bright, high-visibility green used in safety contexts.",
    upcharge: 1.0,
  },
  {
    name: "Schoolbus Yellow",
    mivaname: "Schoolbus_Yellow_0254",
    hex: "#FFD800",
    rgb: "rgb(255, 216, 0)",
    brief: "A vivid yellow matching the classic school bus color.",
    upcharge: 1.0,
  },
  {
    name: "Spring Green",
    mivaname: "Spring_Green_3555",
    hex: "#008E33",
    rgb: "rgb(0, 142, 51)",
    brief: "A bright, fresh green with a cyan tint.",
    upcharge: 1.0,
  },
  {
    name: "Sundance Yellow",
    mivaname: "Sundance_Yellow_0218",
    hex: "#FFB90B",
    rgb: "rgb(255, 185, 11)",
    brief: "A warm, sunny yellow.",
    upcharge: 1.0,
  },
  {
    name: "Teal Blue",
    mivaname: "Teal_Blue_3210",
    hex: "#008080",
    rgb: "rgb(0, 128, 128)",
    brief: "A standard teal, balanced between green and blue.",
    upcharge: 1.0,
  },
  {
    name: "Violet Toner",
    mivaname: "Violet_Toner_0246",
    hex: "#8A2BE2",
    rgb: "rgb(138, 43, 226)",
    brief: "A vibrant violet with a purple-blue mix.",
    upcharge: 1.0,
  },
  {
    name: "White",
    mivaname: "White_5687",
    hex: "#FFFFFF",
    rgb: "rgb(255, 255, 255)",
    brief: "Pure white, standard.",
    upcharge: 1.0,
  },
  {
    name: "Yellow",
    mivaname: "Yellow_2000",
    hex: "#FFFF00",
    rgb: "rgb(255, 255, 0)",
    brief: "Pure yellow, standard.",
    upcharge: 1.0,
  },
];

const BL402COLORS = [
  {
    name: "Brushed Aluminum",
    mivaname: "FCMA_BSA",
    hex: "#A8AAB1",
    rgb: "rgb(168, 170, 177)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Satin Silver Aluminum",
    mivaname: "FCMA_SSA",
    hex: "#C0CAD3",
    rgb: "rgb(192, 202, 211)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Polished Aluminum",
    mivaname: "FCMA_PA",
    hex: "#AEC2CF",
    rgb: "rgb(174,194,207)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Satin Gold",
    mivaname: "FCMA_BSG",
    hex: "#BFC562",
    rgb: "rgb(191, 197, 98)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Brushed Light Brass",
    mivaname: "FCMA_BSB",
    hex: "#D6C65D",
    rgb: "rgb(214, 198, 93)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Brushed Brass",
    mivaname: "FCMA_SSB",
    hex: "#A6914D",
    rgb: "rgb(166, 145, 77)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Polished Brass",
    mivaname: "FCMA_PB",
    hex: "#D4BC5F",
    rgb: "rgb(212,188,95)",
    brief: "Standard.",
    upcharge: 1.0,
  },
  {
    name: "Brushed Medium Bronze",
    mivaname: "FCMA_BBR",
    hex: "#5E4C33",
    rgb: "rgb(94, 76, 51)",
    brief: "Standard.",
    upcharge: 1.0,
  },
];

const PAINTEDCOLORS = [
  {
    name: "Aztec Gold",
    mivaname: "Aztec_Gold_0401",
    hex: "#E27023",
    rgb: "rgb(227, 112, 35)",
    brief: "A warm, muted gold with a bronze undertone.",
    upcharge: 1.0,
  },
  {
    name: "Aztec Copper",
    mivaname: "Aztec_Copper_0402",
    hex: "#C14E2F",
    rgb: "rgb(193, 78, 47)",
    brief: "A rich, earthy copper tone with a brownish hue.",
    upcharge: 1.0,
  },
  {
    name: "Black",
    mivaname: "Black_2025",
    hex: "#000000",
    rgb: "rgb(0, 0, 0)",
    brief: "Pure black, standard.",
    upcharge: 1.0,
  },
  {
    name: "Black Cherry",
    mivaname: "Black_Cherry_2280",
    hex: "#3F1D28",
    rgb: "rgb(63, 29, 40)",
    brief:
      "A deep, dark red with a hint of purple, resembling ripe black cherry.",
    upcharge: 1.0,
  },
  {
    name: "Blue",
    mivaname: "Blue_3000",
    hex: "#0000FF",
    rgb: "rgb(0, 0, 255)",
    brief: "Pure blue, standard primary color.",
    upcharge: 1.0,
  },
  {
    name: "Brick Red",
    mivaname: "Brick_Red_1875",
    hex: "#AE2935",
    rgb: "rgb(174,41,53)",
    brief: "A dark red with looks like bricks,",
    upcharge: 1.0,
  },
  {
    name: "Brilliant Gold",
    mivaname: "Brilliant_Gold_0400",
    hex: "#FFD700",
    rgb: "rgb(255, 215, 0)",
    brief: "A bright, vibrant gold.",
    upcharge: 1.0,
  },
  {
    name: "Brown",
    mivaname: "Brown_2418",
    hex: "#8B4513",
    rgb: "rgb(139, 69, 19)",
    brief: "A medium brown, akin to saddle brown.",
    upcharge: 1.0,
  },
  {
    name: "Citrus Yellow",
    mivaname: "Citrus_Yellow_0217",
    hex: "#FFC107",
    rgb: "rgb(255, 194, 7)",
    brief: "A bright, zesty yellow with an orange tint.",
    upcharge: 1.0,
  },
  {
    name: "Copper",
    mivaname: "Copper_0253",
    hex: "#C65B46",
    rgb: "rgb(198, 91, 70)",
    brief: "A classic copper shade, warm and metallic.",
    upcharge: 1.0,
  },
  {
    name: "Dark Blue",
    mivaname: "Dark_Blue_2050",
    hex: "#00008B",
    rgb: "rgb(0, 0, 139)",
    brief: "A deep navy blue.",
    upcharge: 1.0,
  },
  {
    name: "Dark Green",
    mivaname: "Dark_Green_2030",
    hex: "#006400",
    rgb: "rgb(0, 100, 0)",
    brief: "A rich forest green.",
    upcharge: 1.0,
  },
  {
    name: "Dark Oxide",
    mivaname: "Dark_Oxide_1315",
    hex: "#3E3E3F",
    rgb: "rgb(62,63,63)",
    brief: "Dark brown.",
    upcharge: 1.0,
  },
  {
    name: "Desert Sand",
    mivaname: "Desert_Sand_4660",
    hex: "#EDC9AF",
    rgb: "rgb(237, 201, 175)",
    brief: "A light, warm beige with a sandy tone.",
    upcharge: 1.0,
  },
  {
    name: "Dove Grey",
    mivaname: "Dove_Grey_4310",
    hex: "#878787",
    rgb: "rgb(135, 135, 135)",
    brief: "A light, neutral grey.",
    upcharge: 1.0,
  },
  {
    name: "Duranodic Bronze",
    mivaname: "Duranodic_Bronze_3130",
    hex: "#4A2C2A",
    rgb: "rgb(74, 44, 42)",
    brief: "A dark, metallic bronze often used in industrial finishes",
    upcharge: 1.0,
  },
  {
    name: "Emerald Green",
    mivaname: "Emerald_Green_0222",
    hex: "#007022",
    rgb: "rgb(0, 112, 34)",
    brief: "A bright, jewel-like green.",
    upcharge: 1.0,
  },
  {
    name: "Federal Green",
    mivaname: "Federal_Green_0259",
    hex: "#005123",
    rgb: "rgb(0, 81, 35)",
    brief: "A deep, muted green often used in official or military contexts.",
    upcharge: 1.0,
  },
  {
    name: "Grey",
    mivaname: "Grey_0209",
    hex: "#808080",
    rgb: "rgb(128, 128, 128)",
    brief: "Medium grey, standard.",
    upcharge: 1.0,
  },
  {
    name: "Hunter Green",
    mivaname: "Hunter_Green_2162",
    hex: "#092D17",
    rgb: "rgb(9, 45, 23)",
    brief: "A dark, earthy green associated with forest hunting tones.",
    upcharge: 1.0,
  },
  {
    name: "Ivory",
    mivaname: "Ivory_2718",
    hex: "#FFFFF0",
    rgb: "rgb(255, 255, 240)",
    brief: "A warm off-white.",
    upcharge: 1.0,
  },
  {
    name: "Lemon Yellow",
    mivaname: "Lemon_Yellow_2037",
    hex: "#F2D927",
    rgb: "rgb(242, 217, 39)",
    brief: "A pale, soft yellow like lemon chiffon.",
    upcharge: 1.0,
  },
  {
    name: "Light Blue",
    mivaname: "Light_Blue_2648",
    hex: "#3371DD",
    rgb: "rgb(51, 113, 221)",
    brief: "A soft sky blue.",
    upcharge: 1.0,
  },
  {
    name: "Light Green",
    mivaname: "Light_Green_2108",
    hex: "#075E11",
    rgb: "rgb(7, 94, 17)",
    brief: "A pastel green.",
    upcharge: 1.0,
  },
  {
    name: "Magenta",
    mivaname: "Magenta_2410",
    hex: "#C11A5E",
    rgb: "rgb(193, 26, 94)",
    brief: "Pure magenta, standard.",
    upcharge: 1.0,
  },
  {
    name: "Mango",
    mivaname: "Mango_0254",
    hex: "#FF9A22",
    rgb: "rgb(255, 154, 34)",
    brief: "Dark reddish orange like the Mango fruit.",
    upcharge: 1.0,
  },
  {
    name: "Marine Reef Blue",
    mivaname: "Marine_Reef_Blue_5425",
    hex: "#84A6AD",
    rgb: "rgb(132, 166, 173)",
    brief: "A steel blue with a nautical feel, akin to a coral reef tone.",
    upcharge: 1.0,
  },
  {
    name: "Maroon",
    mivaname: "Maroon_2240",
    hex: "#800000",
    rgb: "rgb(128, 0, 0)",
    brief: "A deep reddish-brown, standard.",
    upcharge: 1.0,
  },
  {
    name: "Medium Blue",
    mivaname: "Medium_Blue_2860",
    hex: "#0000CD",
    rgb: "rgb(0, 0, 205)",
    brief: "A balanced medium blue, slightly darker than pure blue.",
    upcharge: 1.0,
  },
  {
    name: "Medium Bronze",
    mivaname: "Medium_Bronze_0312",
    hex: "#6A4A3C",
    rgb: "rgb(106, 74, 60)",
    brief: "A mid-tone bronze with a warm brown base.",
    upcharge: 1.0,
  },
  {
    name: "Metallic Gold",
    mivaname: "Metallic_Gold_2756",
    hex: "#D4AF37",
    rgb: "rgb(212, 175, 55)",
    brief: "A shiny, metallic gold shade.",
    upcharge: 1.0,
  },
  {
    name: "Metallic Silver",
    mivaname: "Metallic_Silver_8886",
    hex: "#C0C0C0",
    rgb: "rgb(192, 192, 192)",
    brief: "A light, metallic grey resembling silver.",
    upcharge: 1.0,
  },
  {
    name: "Midnight Blue",
    mivaname: "Midnight_Blue_2767",
    hex: "#191970",
    rgb: "rgb(25, 25, 112)",
    brief: "A very dark blue, almost black, evoking a night sky.",
    upcharge: 1.0,
  },
  {
    name: "Old Copper",
    mivaname: "Old_Copper_0314",
    hex: "#73503C",
    rgb: "rgb(115, 80, 60)",
    brief: "A weathered copper tone with a muted, aged appearance.",
    upcharge: 1.0,
  },
  {
    name: "Orange",
    mivaname: "Orange_2119",
    hex: "#FFA500",
    rgb: "rgb(255, 165, 0)",
    brief: "Pure orange, standard.",
    upcharge: 1.0,
  },
  {
    name: "Platinum Grey",
    mivaname: "Platinum_Grey_8808",
    hex: "#9B9B9B",
    rgb: "rgb(155, 155, 155)",
    brief: "A light, metallic grey resembling platinum.",
    upcharge: 1.0,
  },
  {
    name: "Purple",
    mivaname: "Purple_2287",
    hex: "#800080",
    rgb: "rgb(128, 0, 128)",
    brief: "Pure purple, standard.",
    upcharge: 1.0,
  },
  {
    name: "Rampart Orange",
    mivaname: "Rampart_Orange_0256",
    hex: "#FF3000",
    rgb: "rgb(255, 48, 0)",
    brief: "A bold, vibrant orange with a slight reddish tint.",
    upcharge: 1.0,
  },
  {
    name: "Red",
    mivaname: "Red_2793",
    hex: "#FF0000",
    rgb: "rgb(255, 0, 0)",
    brief: "Pure red, standard.",
    upcharge: 1.0,
  },
  {
    name: "Red-Orange",
    mivaname: "Red_Orange_2662",
    hex: "#FF4500",
    rgb: "rgb(255, 069, 0)",
    brief: "A fiery orange-red.",
    upcharge: 1.0,
  },
  {
    name: "Safety Green",
    mivaname: "Safety_Green_8090",
    hex: "#CFEF4B",
    rgb: "rgb(207, 239, 75)",
    brief: "A bright, high-visibility green used in safety contexts.",
    upcharge: 1.0,
  },
  {
    name: "Spring Green",
    mivaname: "Spring_Green_3555",
    hex: "#008E33",
    rgb: "rgb(0, 142, 51)",
    brief: "A bright, fresh green with a cyan tint.",
    upcharge: 1.0,
  },
  {
    name: "Sundance Yellow",
    mivaname: "Sundance_Yellow_0218",
    hex: "#FFB90B",
    rgb: "rgb(255, 185, 11)",
    brief: "A warm, sunny yellow.",
    upcharge: 1.0,
  },
  {
    name: "Teal Blue",
    mivaname: "Teal_Blue_3210",
    hex: "#008080",
    rgb: "rgb(0, 128, 128)",
    brief: "A standard teal, balanced between green and blue.",
    upcharge: 1.0,
  },
  {
    name: "Violet Toner",
    mivaname: "Violet_Toner_0246",
    hex: "#8A2BE2",
    rgb: "rgb(138, 43, 226)",
    brief: "A vibrant violet with a purple-blue mix.",
    upcharge: 1.0,
  },
  {
    name: "White",
    mivaname: "White_5687",
    hex: "#FFFFFF",
    rgb: "rgb(255, 255, 255)",
    brief: "Pure white, standard.",
    upcharge: 1.0,
  },
  {
    name: "Yellow",
    mivaname: "Yellow_2000",
    hex: "#FFFF00",
    rgb: "rgb(255, 255, 0)",
    brief: "Pure yellow, standard.",
    upcharge: 1.0,
  },
];

export const COLOR_MAP = {
  ML1000: PAINTEDCOLORS,
  BL1000: BL10COLORS,
  BL2000: PAINTEDMETALCOLORS,
  BL2200: null,
  BL31000: PAINTEDMETALCOLORS,
  BL40100: PREMIUMCOLORS,
  BL40200: BL402COLORS,
  PFL100: PFL100COLORS,
  BL70100: PAINTEDCOLORS,
};

export const getColorsByProductCode = (productCode) => {
  if (!productCode) {
    console.warn("No product code provided");
    return [];
  }
  const colors = COLOR_MAP[productCode];
  if (!colors) {
    console.warn(`No colors defined for product code: ${productCode}`);
    return [];
  }
  return colors;
};
